import { render, staticRenderFns } from "./field-hockey-icon.vue?vue&type=template&id=f949dbf4"
import script from "./field-hockey-icon.vue?vue&type=script&lang=js"
export * from "./field-hockey-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports